import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ContactService } from '../services/contact.service';
import { CourseService } from '../services/course.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  constructor(
    private courseService: CourseService,
    private router: Router,
    private contactService: ContactService,
    private toastrService: ToastrService) { }
  public panelOpen: any[] = [];
  public topCourses: any[] = [];
  public name: string;
  public description: string;
  public mail: string;
  public courseRelatedQA: any[];
  public generalQA: any[];
  ngOnInit(): void {
    this.courseRelatedQA = [
      {
        question: 'How do I choose a course?',
        answer: 'The courses are categorized based on the subject. You can choose a course that appeals to your area of interest and work. You can also choose a course based on your level of expertise in a particular subject. If you do not find a course, drop us a line, it is probably in the pipeline.',
        active: false
      },
      {
        question: 'How long can I access the course?',
        answer: 'The course is accessible to you using the link provided for the period of your subscription.',
        active: false
      },
      {
        question: 'Can I download the course for viewing later?',
        answer: 'The course cannot be downloaded. You may download the flash cards which will serve as a bench aid.',
        active: false
      },
      {
        question: 'What is the duration of each course?',
        answer: 'The duration varies. The optimal duration will be provided for each course and it is recommended that you complete the same within the time line. ',
        active: false
      },
      {
        question: 'What is a course plan?',
        answer: 'Each course is divided into modules. On completion of each module, you have to take a quiz. You can move on to the next module only on successful completion of the quiz.',
        active: false
      },
      {
        question: 'How can I get my certificate of completion?',
        answer: 'On completion of all modules, the student submits a feedback form. The certificate can be downloaded on successful submission of the feedback form.',
        active: false
      },
      {
        question: 'How can I address my queries on the course content?',
        answer: 'You can send us all queries regarding the course that you have taken from your registered email id to rani.r@thelaboratorymatters.com. The queries will be answered within 7 working days.',
        active: false
      }
    ];
    this.generalQA = [
      {
        question: 'What are the hardware requirements to attend the course?',
        answer: 'The course can be accessed on a smart mobile phone, tablet, laptop or desktop. Suggested browsers are Google chrome, Microsoft edge, Firefox on Windows platform and Safari for iOS. We recommend using a laptop or desktop computer for optimal viewing of the courses. Use of headphones is recommended',
        active: false
      },
      {
        question: 'What type of Internet connection do I require?',
        answer: 'Fixed line Broadband, Wireless connections using 4G and above.',
        active: false
      },
      {
        question: 'How do I make a payment?',
        answer: 'Our website has a payment gateway where payments can be made in a secure manner by Credit cards, UPI and Net banking.',
        active: false
      },
      {
        question: 'Will my payment be refunded if I am unable to attend the programme?',
        answer: 'No, payments will not be refunded.',
        active: false
      }
    ]
    this.panelOpen = [
      { active: false },
      { active: false },
      { active: false },
      { active: false },
      { active: false },
      { active: false },
      { active: false },
      { active: false },
      { active: false },
      { active: false },
      { active: false },
    ];

    this.courseService.topCourses().subscribe(
      (res: any) => {
        this.topCourses = res;
      }
    )
  }

  onClickBtn(type) {
    this.router.navigate([type]);
  }

  onClickArrow(type, index = 0) {
    if (type == 'course')
      this.courseRelatedQA[index].active = !this.courseRelatedQA[index].active;
    else
      this.generalQA[index].active = !this.generalQA[index].active;
  }

  onClickCourse(course) {
    this.router.navigate(['courses/details/' + course._id]);
  }

  onClickSend() {
    this.contactService.sendEmail({
      email: this.mail,
      name: this.name,
      description: this.description
    }).subscribe((response) => {
      this.toastrService.success(response['description']);
    }, error => {
      this.toastrService.error(error.message);
    })
  }

  onClickWorkshop() {
    window.scrollTo(0, 0)
  }
}
